import {
  ACTION_GET_ORG_TRANSACTIONS,
  ACTION_GET_ORG_TRANSACTIONS_SUCCESS,
  ACTION_GET_ORG_TRANSACTIONS_FAILURE,
  ACTION_GET_MORE_ORG_TRANSACTIONS,
  ACTION_GET_MORE_ORG_TRANSACTIONS_SUCCESS,
  ACTION_GET_MORE_ORG_TRANSACTIONS_FAILURE,
  ACTION_EMPTY_ORG_TRANSACTIONS,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

export interface OrgTransactionsParams {
  limit?: number;
  syncToGlStatus?: string;
  dateFrom?: string;
  dateTo?: string;
}

export function getOrgTransactions(organizationId: string, params?: OrgTransactionsParams) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({ type: ACTION_GET_ORG_TRANSACTIONS, payload: null });

    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/synced-transactions`,
        method: 'get',
        data: params || {},
        success: (response: any) => {
          dispatch({ type: ACTION_GET_ORG_TRANSACTIONS_SUCCESS, payload: response });
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch({ type: ACTION_GET_ORG_TRANSACTIONS_FAILURE, payload: error });
        },
      },
    });
  };
}

export function getMoreOrgTransactions(
  organizationId: string,
  params: OrgTransactionsParams,
  cursor: { id: string; created: string },
) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({ type: ACTION_GET_MORE_ORG_TRANSACTIONS, payload: null });

    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/synced-transactions`,
        method: 'get',
        data: {
          ...params,
          'cursor[id]': cursor.id,
          'cursor[created]': cursor.created,
        },
        success: (response: any) => {
          dispatch({ type: ACTION_GET_MORE_ORG_TRANSACTIONS_SUCCESS, payload: response });
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch({ type: ACTION_GET_MORE_ORG_TRANSACTIONS_FAILURE, payload: error });
        },
      },
    });
  };
}

export const emptyOrgTransactions = () => ({ type: ACTION_EMPTY_ORG_TRANSACTIONS, payload: null });
